import { render } from "./CartContent.vue?vue&type=template&id=d8981482&scoped=true"
import script from "./CartContent.vue?vue&type=script&lang=js"
export * from "./CartContent.vue?vue&type=script&lang=js"

import "./CartContent.vue?vue&type=style&index=0&id=d8981482&scoped=true&lang=css"

import exportComponent from "/Users/lindelwankosinathi/Documents/projects/renaissancecs/node_modules/.pnpm/vue-loader@16.8.3_vue@3.2.39+webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d8981482"]])

export default __exports__